import React, {useEffect} from 'react';

import registerAnimations from './registerAnimations';

import './WoolCross.scss';

import staticFootbed from '../../static/images/woolcross/footbed.png';

import staticSec11Shoe from '../../static/images/woolcross/sec11-shoe.png';
import staticSec11ShoeWater from '../../static/images/woolcross/sec11-shoe-water.png';
import staticSec11Bg from '../../static/images/woolcross/sec11bg.jpg';

import staticSec12Bg from '../../static/images/woolcross/sec12-bg.jpg';
import staticSec12BgMobile from '../../static/images/woolcross/sec12-bg-sm.jpg';

import quote from './../../static/images/merinowool/quote.png';

import staticTestimonialShoeImage from '../../static/images/woolcross/upsell.png';
import TrustpilotWidget from '../TrustpilotWidget/TrustpilotWidget';

const WoolCross2 = (props) => {
    const {
        sec10Text,
        sec10ButtonText,
        sec10ButtonUrl,

        sec11Text,
        bgSec11,

        bgSec12,
        bgSec12Mobile,
        sheepText, 
        sheepButtonUrl,
        sheepButtonText,

        testimonialShoeImage,
        testimonialText,
        testimonialButton1Url,
        testimonialButton1Text,
        testimonialButton2Url,
        testimonialButton2Text,
    } = props

    useEffect(() => {
        registerAnimations();
      }, [])


    return (
        <div className="landingpage-woolcross">



            <section className="sec sec10 footbed bg-dark text-white  d-flex position-relative">
                <div className="container d-flex flex-grow-1 position-static">
                <div className="row flex-grow-1">
                    <article className="content-2 col-12 col-md-6 col-lg-6 col-xl-5 mb-xl-5  mb-lg-0 ml-md-auto order-md-2 align-self-center align-self-xl-end pl-xl-5 ">
                        {sec10Text}
                    <p className="mt-lg-5 d-flex mb-0"><a href={sec10ButtonUrl} className="btn btn-outline-light">{sec10ButtonText}</a></p>
                    </article>
                    <figure className="col-12 col-md-6 order-md-1 align-self-center position-static">
                    <p className="hide animated">
                        <img src={staticFootbed} alt="" className="d-md-block footbed-img" />
                    </p>
                    </figure>
                </div> 
                </div>
            </section>

            <style>
            {`
                .sec11 {
                    background:url(${bgSec11});
                }
            `}
            </style>
            <section className="sec sec11 d-flex">
                <div className="container d-flex flex-grow-1">
                <div className="row  flex-grow-1">
                    <article className="content col-10 col-sm-9 col-md-6 col-lg-6 col-xl-6 mr-auto  pt-xl-5 mt-xl-5">
                        {sec11Text}
                    </article>
                    <div className=" col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 ml-auto text-center ">
                    <figure className="figure position-relative mb-0 d-md-inline-block">
                        <img src={staticSec11Shoe} alt="" className="shoe hide animated" />
                        <img src={staticSec11ShoeWater} alt="" className="shoe-water hide animated delay-2" />
                    </figure>
                    </div>
                </div>
                </div>
            </section> 

            <style>
                {`
                .sec12 {
                    background:url(${bgSec12Mobile});
                }

                @media (min-width: 768px) {
                    .sec12 {
                    background-image: url(${bgSec12});
                    }
                }
                `}
            </style>

            <section className="sec sec12 d-flex">
                <div className="container d-flex flex-grow-1">
                <div className="row d-flex flex-grow-1">
                    <article className="content col-11 col-md-6 col-lg-5 col-xl-5  mb-lg-0 ml-md-auto align-self-center pl-xl-5">
                    {sheepText}
                    <p className="d-lg-block pt-3"><a href={sheepButtonUrl} className="btn btn-outline-light">{sheepButtonText}</a></p>
                    </article>
                </div>
                </div>
            </section>

            <section className="sec py-5 testimonials">
                    <div className="container">
                    <p className="text-center qoute pb-4"><img src={quote} alt="" /></p>
                    </div>
                    <div className="trustBox-widget py-4 py-lg-5 mb-5">
                    <div className="container">
                        <TrustpilotWidget />
                    </div>
                    </div>
                    <div className="testimonials-products">
                    <div className="container">
                        <div className="row">
                        <figure className="d-none d-md-block col-12 col-md-5">
                            <p><img src={testimonialShoeImage} alt="" /></p>
                        </figure>
                        <article className="content col-12 col-md-7 mb-lg-0 ml-md-auto">
                            {testimonialText}
                            <figure className="d-md-none"><img src={testimonialShoeImage} alt="" /></figure>
                            <p className="mt-5 row compact btn-cont">
                            <span className="col-6"><a href={testimonialButton1Url} className="btn btn-dark btn-block d-md-inline-block mb-3">{testimonialButton1Text}</a></span>
                            <span className="col-6"><a href={testimonialButton2Url} className="btn btn-dark btn-block d-md-inline-block mb-3">{testimonialButton2Text}</a></span>
                            </p>
                        </article>
                        </div>
                    </div>
                    </div>
            </section>

        </div>
    )
}


WoolCross2.defaultProps = {

    sec10Text:<>
    <h2>CHANGEABLE <br /> <strong>FOOTBED</strong></h2>
    <p className="mr-xl-4">A performance footbed with an all-day shock-absorbing effect. Made of soft Merino wool.</p>
    </>,
    sec10ButtonUrl:"#",
    sec10ButtonText:"BUY FOOTBED",
    footBed: staticFootbed,


    sec11Text:<>
      <h2>Off to the <br /><strong>washing machine</strong></h2>
                    <p className="pr-xl-4  mr-xl-1">Your Wool Cross X is dirty? Just wash it in the washing machine (cold water, 30°C, gentle cycle, no fabric softener). Then let the shoes air-dry (not in the dryer) and they are ready for the next training session. </p> 
    </>,
    bgSec11:staticSec11Bg,
    sec11shoe:staticSec11Shoe,
    sec11water:staticSec11ShoeWater,

    sheepText: <>
    <h2><strong>Green</strong> <br /> Strategy</h2>
    <p>Throughout the three generations of our company’s family owned and operated business, we’ve learned to combine our knowledge of wool craftsmanship with modern, green thinking about the environment and animal protection</p>
    </>,
    sheepButtonText: 'KNOW MORE',
    sheepButtonUrl: '#',
    bgSec12: staticSec12Bg,
    bgSec12Mobile: staticSec12BgMobile,

      testimonialShoeImage: staticTestimonialShoeImage,
  testimonialText: <>
    <h3><strong>These Clients bought this shoe, </strong>  Maybe try this one too</h3>
  </>,
  testimonialButton1Text: 'WOMEN',
  testimonialButton2Text: 'MEND',
  testimonialButton1Url: '#',
  testimonialButton2Url: '#',

}

export default WoolCross2;